const ScrollReveal = {};

ScrollReveal.scrollClass = '.slide-up';
// Get all the elements with the .animate class applied
ScrollReveal.allAnimatedElements = document.querySelectorAll(ScrollReveal.scrollClass);
ScrollReveal.observer = null;
ScrollReveal.bottom = -25;

/**
 * Handle the scroll event
 */
function handleScroll(initialPosition) {
	var showThresholdBottom = (initialPosition === true) ? 0 : ScrollReveal.bottom;
	ScrollReveal.allAnimatedElements.forEach(function (el) {
		var rect = el.getBoundingClientRect(),
			//validShow = (rect.top < window.innerHeight - 50 && rect.bottom >= 0),
			$tEl = $(el);
		if ($tEl.data('show') !== true && (rect.top < window.innerHeight - showThresholdBottom && rect.bottom <= window.innerHeight + rect.height)) {
			el.classList.add('reveal');
			$tEl.data('show', true);
		} else if ($tEl.data('show') === true && !(rect.top < window.innerHeight - showThresholdBottom && rect.bottom <= window.innerHeight + rect.height)) {
			el.classList.remove('reveal');
			$tEl.data('show', false);
		}
	});
}

/**
 * Start listening to scroll events
 */
ScrollReveal.start = function (tClass) {
	//var self = this;
	ScrollReveal.scrollClass = (tClass) ? tClass : ScrollReveal.scrollClass;

	// update allAnimatedElements
	ScrollReveal.allAnimatedElements = document.querySelectorAll(ScrollReveal.scrollClass);

	// listen to scroll events
	window.addEventListener('scroll', handleScroll);

	// perform a scroll position check
	handleScroll(true);
};

/**
 * Stop listening to scroll events
 */
ScrollReveal.stop = function () {
	// Stop listening to scroll events
	window.removeEventListener('scroll', handleScroll);
};

module.exports = ScrollReveal;
